'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['post'],
    data: function data() {
        return {
            baseUrl: this.$root.$data.baseUrl
        };
    },
    ready: function ready() {
        this.$set('baseUrl', this.$root.$data.baseUrl);
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"stream__social\">\n    <a href=\"https://www.facebook.com/sharer/sharer.php?u={{ post.origin_link }}&amp;t=url+encoded+text\" class=\"social__iconWrapper\">\n        <svg class=\"\">\n            <use xlink:href=\"{{ baseUrl }}/assets/images/svg/sprite/sprite.svg#icon-facebook\"></use>\n        </svg>\n    </a>\n\n    <a href=\"http://pinterest.com/pin/create/button/?url={{ post.origin_link }}&amp;media={URI-encoded URL of the image to pin}&amp;description={optional URI-encoded description}\" class=\"social__iconWrapper\">\n        <svg class=\"\">\n            <use xlink:href=\"{{ baseUrl }}/assets/images/svg/sprite/sprite.svg#icon-pinterest\"></use>\n        </svg>\n    </a>\n    <a href=\"whatsapp://send?text={{ post.origin_link }}\" class=\"social__iconWrapper social__whatsapp\">\n        <svg class=\"\">\n            <use xlink:href=\"{{ baseUrl }}/assets/images/svg/sprite/sprite.svg#icon-whatsapp\"></use>\n        </svg>\n    </a>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-638843e2", module.exports)
  } else {
    hotAPI.update("_v-638843e2", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}